import { Component } from '@angular/core';
import { CapturumSharedModule } from '@capturum/ui/api';
import { SafeHtmlPipe } from '@core/directives/safe-html.pipe';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-checkbox-wrapper',
  template: `
    <div class="checkbox-wrapper" [class.disabled]="props.disabled">
      <div class="input-group">
        <ng-template #fieldComponent />

        @if (!props.hideLabel) {
          <label class="form-check-label" [innerHTML]="props.translateLabel | safeHtml"></label>
        }
      </div>

      @if (showError) {
        <div class="invalid-feedback" [style.display]="'block'">
          <cap-validator [control]="field.formControl" />
        </div>
      }
    </div>
  `,
  styles: ['.checkbox-wrapper { margin-bottom: 1rem;}'],
  imports: [CapturumSharedModule, SafeHtmlPipe],
})
export class FormlyCheckboxWrapperComponent extends FieldWrapper {}
